import styled from "styled-components";
import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAppContext } from "../Context/Context";
import { setOpenSideBar } from "../redux/slices/appSlice";

const sidebarConfig = [
  {
    id: 1,

    link: "/users/dashboard",
    title: "Overview",
  },
  {
    id: 2,

    link: "/users/listen",
    title: "Listen",
  },
  {
    id: 3,

    link: "/users/recordings",
    title: "Recordings",
  },
  {
    id: 4,

    link: "/users/events",
    title: "Events",
  },

  {
    id: 5,

    link: "/users/stats",
    title: "Stats",
  },
  {
    id: 6,

    link: "/users/moderator",
    title: "Moderator",
  },
  {
    id: 7,

    link: "/users/settings",
    title: "Settings",
  },

  {
    id: 8,

    link: "/users/pricing",
    title: "Pricing",
  },
  // {
  //   id: 9,

  //   link: "/users/test",
  //   title: " Test",
  // },
  // {
  //   id: 10,

  //   link: "/users/test-two",
  //   title: "Two Test",
  // },
  // {
  //   id: 11,

  //   link: "/users/test-three",
  //   title: "Three Test",
  // },
];

export default function UserSidebar() {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const { isSidebarOpen, setIsSidebarOpen, setIsProfileOpen } = useAppContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleNavClick(title) {
    setActiveTab(title);
    setIsSidebarOpen(false);
    setIsProfileOpen(false);
    if (openSideBar) {
      dispatch(setOpenSideBar());
    }
  }

  const { openSideBar } = useSelector((state) => state.app);

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
    if (openSideBar) {
      dispatch(setOpenSideBar());
    }
  };

  return (
    <SIDEBAR data-open={openSideBar ? "closed" : "open"}>
      <div className="sidebar-inner">
        <div className="sidebar-header">
          {/* <button type="button" className="close-button" onClick={handleCloseSidebar}>
            <Icon icon="prime:times" width="22" height="22" />
          </button> */}
          <img src="/images/logo.png" alt="Pluglr logo" className="logo" />
        </div>

        <div className="nav-container">
          <div className="wrapper">
            <div className="nav-links">
              {sidebarConfig.map(({ link, title }, index) => (
                <Link
                  className={`nav-link react-router-link ${
                    activeTab === title ? "active-tab" : ""
                  }`}
                  to={link}
                  key={index}
                  onClick={() => handleNavClick(title)}
                >
                  {title}
                </Link>
              ))}
            </div>
          </div>

          <div className="help-center" />
        </div>
      </div>
      <Closer
        style={{ display: "flex" }}
        onClick={() => {
          setIsSidebarOpen(false);
        }}
      ></Closer>
    </SIDEBAR>
  );
}
const SIDEBAR = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .sidebar-header {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    /* justify-content: space-between;
    width: 100%; */
  }

  .sidebar-inner {
    width: 250px;
    min-height: 100vh;
    padding: 32px 20px;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .logo {
    width: 160px;
  }

  .close-button {
    display: none;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid rgba(15, 23, 42, 0.1);
    background: #ffffff;
    cursor: pointer;
  }

  .nav-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 100px;
    align-items: flex-start;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
  }

  .nav-links {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }

  .help-center {
    width: 100%;
    min-height: 120px;
  }
  .nav-link {
    font-weight: 500 !important;
    color: #818893 !important;
    display: flex;
    font-size: 14px !important;
    justify-content: left !important;
    text-decoration: none !important;
    gap: 15px;
    align-items: center;
    &:hover {
      font-weight: 600 !important;
      color: #060b13 !important;
      transition: 0.3s;
    }
  }
  .active-tab {
    font-weight: 600 !important;
    color: #060b13 !important;
    border-right: 3px solid #000000;
  }

  @media screen and (max-width: 1120px) {
    .sidebar-inner {
      width: 250px;
      padding: 32px 18px;
      background: #ffffff;
      min-height: 100vh;
      margin-top: 80px;
    }

    .close-button {
      display: inline-flex;
    }
  }
`;
const Closer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: rgba(3, 7, 18, 0.45);
  backdrop-filter: blur(2px); */
  /* opacity: 0; */
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 900;

  &.visible {
    opacity: 1;
    pointer-events: auto;
  }

  @media screen and (min-width: 1121px) {
    display: none;
  }
`;
